<script>
import Layout from "../../../layouts/auth";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Lupa Kata Sandi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  created() {
    setTimeout(() => {
      localStorage.removeItem("emailOTP");
      localStorage.removeItem("otpCode");
      location.href = `${process.env.BASE_URL}login`;
    }, 3000);
  },
  data() {
    return {
      email: "",
    };
  },
};
</script>
<template>
  <Layout>
    <div class="mc-auth__form">
      <h1 class="mc-auth__logo pt-5">
        <router-link to="/">
          <img src="@/assets/images/main-logo.png" alt />
        </router-link>
      </h1>
      <div class="mc-auth__form-wrapper mc-auth__form-wrapper--forgot">
        <div class="mc-upload">
          <div class="mc-upload-result mc-upload-result--success">
            <figure>
              <img src="@/assets/images/success-icon.png" alt />
            </figure>
            <h4 class="mc-upload-result__label">
              Berhasil Atur Ulang Katasandi
            </h4>
          </div>
        </div>
      </div>
      <div class="mc-auth__copyright">
        <span
          >Dipersembahkan oleh
          <img src="@/assets/images/copyright-logo.png" alt height="18" class="mt-2"
        /></span> 
      </div>
    </div>
  </Layout>
</template>
